import { h, FunctionComponent } from 'preact';
import { TabContainer, TabContent } from './Tabs.styles';

export interface TabProps {
  id: string | number;
  children?: any;
}

const Tab: FunctionComponent<TabProps> = ({ id, children }) => {
  return (
    <TabContainer data-key={id}>
      <TabContent>{children}</TabContent>
    </TabContainer>
  );
};

export default Tab;
